import { defineStore } from 'pinia';

export const STEP_ORDER = ['Models', 'Trims', 'Options', 'Request'] as const;
export type StepName = (typeof STEP_ORDER)[number];

const TAB_META: Record<StepName, { icon: string }> = {
  Models: { icon: 'fa fa-shield' },
  Trims: { icon: 'fa fa-check-square' },
  Options: { icon: 'fa fa-th-large' },
  Request: { icon: 'fa fa-bookmark' },
};

export const useVariablesStore = defineStore('useVariablesStore', {
  state: () => ({
    currentStep: 'Models' as StepName,
    tab: {
      name: 'Models' as StepName,
      icon: 'fa fa-shield',
      isActive: false,
    },
    requestOrder: false,
    steps: ['Models'] as StepName[],
    selectedForCompare: [] as Array<Record<string, unknown>>,
    selectVariants: [] as Array<Record<string, unknown>>,
  }),
  persist: {
    storage: sessionStorage,
    omit: ['currentStep'],
  },
  actions: {
    unlockThrough(step: StepName) {
      const idx = STEP_ORDER.indexOf(step);
      if (idx < 0) return;
      this.steps = STEP_ORDER.slice(0, idx + 1) as StepName[];
    },
    setCurrentStep(step: StepName) {
      this.unlockThrough(step);
      this.currentStep = step;
      this.tab = {
        name: step,
        icon: TAB_META[step].icon,
        isActive: false,
      };
    },
    goToNextStep() {
      const idx = STEP_ORDER.indexOf(this.currentStep);
      if (idx < 0 || idx >= STEP_ORDER.length - 1) return;
      const next = STEP_ORDER[idx + 1];
      this.setCurrentStep(next);
    },
  },
});
